import { type FunctionComponent } from 'react';
import { ReactComponent as RedStripSVG } from '../../assets/icons/mevo/medicine/tarjavermelha.svg';
import IconPattern, { IconProps } from './_IconPattern';

const MedicineRedStripIcon: FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={RedStripSVG} variantPlaces={[]} {...props} />;
};

export default MedicineRedStripIcon;
